<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">
          <basic-toolbar :title="'Pesquisar Ações de Extensão'"></basic-toolbar>
          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
              <v-container  @keyup.enter="pesquisar()">

                <v-layout row wrap justify-space-between>
                  <v-flex xs11 sm2>
                    <v-text-field
                      label='Número'
                      v-model="pesquisa.numero"
                      max-height="400"
                      clearable>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs11 sm9>
                    <v-text-field
                      label='Título'
                      v-model="pesquisa.titulo"
                      max-height="400"
                      clearable>
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row wrap justify-space-between>
                  <v-flex xs11 sm5>
                    <v-text-field
                      label='Palavra-chave'
                      v-model="pesquisa.palavraChave"
                      max-height="400"
                      clearable>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs11 sm5>
                    <v-text-field
                      label='Membro da equipe'
                      v-model="pesquisa.membroEquipe"
                      max-height="400"
                      clearable>
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row wrap justify-space-between>
                  <v-flex xs12 style="padding-top:15px">
                    <div align="center">
                      <v-btn style="margin-right: 10px;" color="primary" @click="limpar">Limpar</v-btn>
                      <v-btn color="primary" @click="pesquisar">Pesquisar</v-btn>
                    </div>
                  </v-flex>
                </v-layout>

              </v-container>
            </v-form>
          </v-card-text>
        </v-card>

        <br><br><br><br>

        <v-card class="text-xs-center">
          <basic-toolbar :title="'Selecionar Ação de Extensão'"></basic-toolbar>
          <v-card-text>
            <v-layout align-center justify-center>
              <v-flex xs12>
                <div class="instrucao">
                  <v-card outlined>
                    <v-card-text class="black--text font-weight-bold">
                      A vinculação das ações de extensão deve ser feita do menor para o maior nível hierárquico. 
                      Exemplo: projetos podem ser vinculados a programas; cursos/eventos/prestações de serviço podem ser vinculados a projetos ou programas.
                    </v-card-text>
                  </v-card>
                </div>
              </v-flex>
            </v-layout>
            <v-data-table
            :headers="headers"
            :items="listaProjetos"
            :search="search"
            :no-data-text="'Nenhum projeto encontrado'"
            must-sort
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :items-per-page="itemsPerPage"
            :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"

            >
              <template v-slot:item.titulo="props">
                <router-link target="_blank" :to="{ name: 'ProjetoFormulario', params: { idProjeto: props.item.idProjeto }}">{{ props.item.titulo }}</router-link>
              </template>
              <template v-slot:item.opcoes="props">
                <v-btn color="primary" @click="projetoSuperior(props.item.idProjeto)">Selecionar</v-btn>
              </template>
              <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
                Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaProjetos.length }} projetos
              </template>
            </v-data-table>

            <br>

            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary" text @click="$router.go(-1)">Cancelar</v-btn>
            </v-card-actions>

          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import projetos from '@/utils/projetos'
  import { mapActions } from 'vuex'

  export default {
    props: ['idProjeto'],
    data: () => ({
      dialog: false,
      formularioValido: false,
      idProjetoSuperior: undefined,
      pesquisa: {
        numero: null,
        titulo: '',
        membroEquipe: '',
        palavraChave: ''
      },
      listaProjetos: [],
      regrasBasicas: [
        (input) => !!input || 'Este campo é obrigatório'
      ],
      search: null,
      sortBy: 'dtCriacao',
      sortDesc: true,
      itemsPerPage: 25,
      opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
      headers: [
        { text: 'Número', align: 'center', value: 'idProjeto' },
        { text: 'Título', align: 'center', value: 'titulo' },
        { text: 'Classificação Primária', align: 'center', value: 'classificacaoPrimaria' },
        { text: 'Classificação Secundária', align: 'center', value: 'classificacaoSecundaria' },
        { text: 'Situação', align: 'center', value: 'situacao' },
        { text: 'Coordenador', align: 'center', value: 'nomeCoordenador' },
        { text: 'Opções', align: 'center', value: 'opcoes' }
      ]
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      cancelar: function () {
        this.$router.go(-1)
      },
      limpar () {
        this.pesquisa = { tipoProjeto: 39725 }
      },
      pesquisar () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projetos.' })
        projetos.getConsultaProjetos(this.pesquisa)
        .then(response => {
          this.listaProjetos = response.data.slice()
          console.log(this.listaProjetos)
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
          this.listaProjetos = []
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projetos.' })
        })
      },
      projetoSuperior: function (idProjetoSuperior) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Definindo ação superior...' })
        projetos.postProjetoSuperior(this.idProjeto, idProjetoSuperior)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          this.$router.go(-1)
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Definindo ação superior...' })
        })
      }
    },
    mounted () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      projetos.getProjeto(this.idProjeto)
      .then(response => {
        this.projeto = response.data
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip
    }
  }
</script>

<style lang="css" slot-scoped>

.instrucao {
    text-align: justify;
    margin-top: 1em;
    margin-bottom: 3em;
  }

</style>



// WEBPACK FOOTER //
// editar-projeto-superior.vue?7b0a3e7c